"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomOption = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
// Icons:
var IconCheck = function IconCheck(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    stroke: "#979797",
    fill: "none",
    d: "M0 5.274L4.367 9 13 0"
  }));
};
IconCheck.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 10"
};
var IconStar = function IconStar(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    className: "star_svg__path1",
    d: "M12.633 19.484l-7.388 3.884 1.411-8.226L.679 9.316l8.26-1.2L12.633.631l3.694 7.485 8.26 1.2-5.977 5.826 1.411 8.226z"
  }));
};
IconStar.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 24"
};
var DEPARTURE_ID = /*#__PURE__*/function (DEPARTURE_ID) {
  DEPARTURE_ID[DEPARTURE_ID["Moscow"] = 213] = "Moscow";
  DEPARTURE_ID[DEPARTURE_ID["StPetersburg"] = 2] = "StPetersburg";
  return DEPARTURE_ID;
}(DEPARTURE_ID || {});
var CustomOption = exports.CustomOption = /*#__PURE__*/_react["default"].memo(function (optionProps) {
  var data = optionProps.data,
    innerProps = optionProps.innerProps,
    isSelected = optionProps.isSelected,
    innerRef = optionProps.innerRef,
    isFocused = optionProps.isFocused;
  var id = data.id,
    name_ru = data.name_ru;
  var className = isSelected ? 'departure-picker__selected-option' : '';
  var withStar = id === DEPARTURE_ID.Moscow;
  var isHighlighted = withStar || id === DEPARTURE_ID.StPetersburg;
  var notFound = id === -1;
  return /*#__PURE__*/_react["default"].createElement(StyledDeparture, (0, _extends2["default"])({
    ref: innerRef,
    className: className
  }, innerProps, {
    isHighlighted: isHighlighted,
    isFocused: isFocused,
    notFound: notFound
  }), name_ru, " ", withStar && /*#__PURE__*/_react["default"].createElement(StyledIconStar, null), isSelected && /*#__PURE__*/_react["default"].createElement(StyledIconCheck, null));
});
CustomOption.displayName = 'CustomOption';
var StyledDeparture = _styledComponents["default"].div.withConfig({
  displayName: "CustomOption__StyledDeparture",
  componentId: "sc-1nhr8vi-0"
})(["display:flex;align-items:center;padding:0 8px;border-top:1px solid ", ";width:100%;height:48px;font-size:14px;line-height:16px;font-weight:500;background-color:", ";&:hover{cursor:pointer;background-color:", ";}&:first-child{border-top:none;}", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.whiteLight;
}, function (_ref2) {
  var isFocused = _ref2.isFocused,
    theme = _ref2.theme;
  return isFocused && theme.colors.solitude;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.solitude;
}, function (_ref4) {
  var notFound = _ref4.notFound;
  return notFound && 'text-align: center; color: grey;';
});
var StyledIconStar = (0, _styledComponents["default"])(IconStar).withConfig({
  displayName: "CustomOption__StyledIconStar",
  componentId: "sc-1nhr8vi-1"
})(["width:14px;height:14px;fill:#d0021b;margin-left:5px;"]);
var StyledIconCheck = (0, _styledComponents["default"])(IconCheck).withConfig({
  displayName: "CustomOption__StyledIconCheck",
  componentId: "sc-1nhr8vi-2"
})(["margin-left:auto;margin-right:10px;stroke:#17181a;"]);